// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_jHZ","cls2":"RelatedPapers-cls2_4ql RelatedPapers-cls1_jHZ"};